var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "table-pagination" }, [
    _c(
      "div",
      { staticClass: "table-pagination__page-size-selector" },
      [
        _c("label", [_vm._v(_vm._s(_vm.$t("table.showing")))]),
        _c("pui-form-select", {
          attrs: {
            options: _vm.paginationOptions,
            value: _vm.selectedPageSize.toString(),
            label: "",
            "search-input-placeholder": " ",
          },
          on: { change: _vm.onPageSizeChange },
        }),
        _c("label", [
          _vm._v(
            _vm._s(_vm.$t("table.recordCount", { totalCount: _vm.totalCount }))
          ),
        ]),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "table-pagination__page-selector" },
      [
        _vm.selectedPageNumber !== 1
          ? _c(
              "span",
              {
                staticClass: "table-pagination__page-selector__first-page",
                on: { click: _vm.goToFirstPage },
              },
              [_vm._v(" " + _vm._s(_vm.$t("table.first")) + " ")]
            )
          : _vm._e(),
        _c("pui-pagination", {
          attrs: { "range-of-pages": 9, "total-pages": _vm.totalPages },
          on: { "changed:page": _vm.pageNumberChanged },
          model: {
            value: _vm.selectedPageNumber,
            callback: function ($$v) {
              _vm.selectedPageNumber = $$v
            },
            expression: "selectedPageNumber",
          },
        }),
        _vm.selectedPageNumber !== _vm.totalPages
          ? _c(
              "span",
              {
                staticClass: "table-pagination__page-selector__last-page",
                on: { click: _vm.goToLastPage },
              },
              [_vm._v(" " + _vm._s(_vm.$t("table.last")) + " ")]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }